export const FACTORY_MENU = [
    {
        icon: 'assets/icon/crm.svg',
        heading: "Factory",
        sub_heading: [{

            router_link: "/admin/product-advice",
            is_favorite: false,
            label: "Production Advice",

        },
        {

            router_link: "/admin/productions",
            is_favorite: false,
            label: "Productions",

        },
        {

            router_link: "/admin/factory-projection-listing",
            is_favorite: false,
            label: "Factory projection",

        },
        {

            router_link: "/admin/machine",
            is_favorite: false,
            label: "Machines",
            hideFor: ['FACTORY_MANAGER'],

        },
        {

            router_link: "/admin/Factory/QC_Permitted_Deviation",
            is_favorite: false,
            label: "QC permitted deviations",
            hideFor: ['FACTORY_MANAGER'],

        },
        {

            router_link: "/admin/Factory/weighing machines listing",
            is_favorite: false,
            label: "Weighing Machines",
            hideFor: ['FACTORY_MANAGER'],

        },
        {

            router_link: "/admin/Factory/factory-punching",
            is_favorite: false,
            label: "Factory Punching",
            hideFor: ['FACTORY_MANAGER'],

        },
        {

            router_link: "/admin/Factory/factory-devices",
            is_favorite: false,
            label: "Factory Devices",
            hideFor: ['FACTORY_MANAGER'],

        },
        {

            router_link: "/admin/Factory/mobile-punching",
            is_favorite: false,
            label: "Mobile Punching",
            hideFor: ['FACTORY_MANAGER'],

        },
        {

            router_link: "/admin/Factory/factory-department",
            is_favorite: false,
            label: "Factory Department",
            hideFor: ['FACTORY_MANAGER'],

        }
        ]
    },
    {
        icon: 'assets/icon/crm.svg',
        heading: "Factory Settings",
        hideFor: ['FACTORY_MANAGER'],
        sub_heading: [
        //     {
        //     label: "Settings",
        //     router_link: "/admin/Factory/factory-settings-listing",
        //     is_favorite: false,
        // },
        {
            label: "Tank",
            router_link: "/admin/Factory/tank-master",
            is_favorite: false,
        },
        {
            label: "Maintenance Employees",
            router_link: "/admin/Factory/maintenance-employees-listing",
            is_favorite: false,
        },
        {
            label: "RM QC Technicians",
            router_link: "/admin/Factory/rm-qc-technicians-list",
            is_favorite: false,
        },
        {
            label: "Process QC Technicians",
            router_link: "/admin/Factory/process-qc-technicians-list",
            is_favorite: false,
        },
        {
            label: "Packing operators",
            router_link: "/admin/Factory/packing-operators-list",
            is_favorite: false,
        },
        {
            label: "Rm Transfer Weighing Access",
            router_link: "/admin/Factory/rm-transfer-weighing-access-list",
            is_favorite: false,
        },
        {
            label: "Milling Required Process Category",
            router_link: "/admin/Factory/milling-required-category-list",
            is_favorite: false,
        }
        ]
    },
    {
        icon: 'assets/icon/crm.svg',
        heading: "Machine/Equipments",
        sub_heading: [
            {
                label: "Plant Location",
                router_link: "/admin/Factory/plant-location-list",
                is_favorite: false,
                hideFor: ['FACTORY_MANAGER'],
            },
            {
                label: "Functional Area",
                router_link: "/admin/Factory/functional-area-list",
                is_favorite: false,
                hideFor: ['FACTORY_MANAGER'],
            },
            {
                label: "Maintenance Machine",
                router_link: "/admin/Factory/maintenance-list",
                is_favorite: false,
                hideFor: ['FACTORY_MANAGER'],
            },
            {
                label: "Machine Type",
                router_link: "/admin/Factory/machine-type-list",
                is_favorite: false,
                hideFor: ['FACTORY_MANAGER'],
            },
            
        ]
    },
    {
        icon: 'assets/icon/crm.svg',
        heading: "Reports",
        sub_heading: [
            //     {
            //     label:"Packing report",
            //     router_link:"/admin/Factory/packing-report",
            //     is_favorite:false,
            // },
            {
                label: "Production Dashboard",
                router_link: "/admin/Factory/factory-dashboard",
                is_favorite: false,
            },
            {
                label: "RM QC Dashboard",
                router_link: "/admin/Factory/rm-qc-dashboard",
                is_favorite: false,
            },
            {
                label: "Process QC Dashboard",
                router_link: "/admin/Factory/process-qc-dashboard",
                is_favorite: false,
            },
            
            {
                label: "RM QC Process Summary Report",
                router_link: "/admin/Factory/rm-qc-summary",
                is_favorite: false,
            },
            {
                label: "QC Process Summary Report",
                router_link: "/admin/Factory/qc-summary",
                is_favorite: false,
            },
            {
                label: "Production Process Summary Report",
                router_link: "/admin/Factory/process-summary",
                is_favorite: false,
            },
            {
                label: "Packing Process Summary Report",
                router_link: "/admin/Factory/packing-process-summary-detail",
                is_favorite: false,
            },
            {
                label: "Production Status Report",
                router_link: "/admin/Factory/production-status-report",
                is_favorite: false,
            },
            {
                label: "Batch Posting Summary Report",
                router_link: "/admin/Factory/batch-posting-summary-report",
                is_favorite: false,
            },
            
            {
                label: "Person Wise Monthly Report",
                router_link: "/admin/Factory/person-wise-monthly-report",
                is_favorite: false,
            },
            {
                label: "Batch Wise Report",
                router_link: "/admin/Factory/batchwise-report",
                is_favorite: false,
            },
            {
                label: "Leads and Throughput Summary Report",
                router_link: "/admin/Factory/leads-report",
                is_favorite: false,
            },
            {
                label: "Production Quality Excellence Report",
                router_link: "/admin/Factory/quality-excellence-report",
                is_favorite: false,
            },
            {
                label: "Maintenance Dashboard",
                router_link: "/admin/Factory/kpi-dashboard-list",
                is_favorite: false,
            },
            {
                label: "RM Quality Excellence Report",
                router_link: "/admin/Factory/rm-quality-excellence-report",
                is_favorite: false,
            },
            
        ]
    },

    {
        icon: 'assets/icon/crm.svg',
        hideFor: ['FACTORY_MANAGER'],
        heading: "Bench mark Matrixes",
        sub_heading: [
            {
                label: "Packing Cycle Time",
                router_link: "/admin/Factory/packing-cycle-time-listing",
                is_favorite: false,
            },
            {
                label: "RM Deviation Matrix",
                router_link: "/admin/Factory/rm-deviation-matrix-listing",
                is_favorite: false,
            },
            {
                label: "Loss Deviation Matrix",
                router_link: "/admin/Factory/loss-deviation-matrix-listing",
                is_favorite: false,
            },
            {
                label: "Intermediate Production Cycle Time",
                router_link: "/admin/Factory/intermediate-production-cycle-time-listing",
                is_favorite: false,
            },
            {
                label: "RM QC Cycle Time",
                router_link: "/admin/Factory/rm-qc-cycle-time-matrix-listing",
                is_favorite: false,
            },
            {
                label: "Process QC Cycle Time",
                router_link: "/admin/Factory/process-qc-cycle-time-matrix-listing",
                is_favorite: false,
            },
            {
                label: "Batch Posting Cycle Time",
                router_link: "/admin/Factory/batch-posting-cycle-time-listing",
                is_favorite: false,
            },
            
            {
            label: "Target Weighted Production",
            router_link: "/admin/Factory/target-weighted-production-listing",
            is_favorite: false,
            },
            {
            label: "Intermediate Product Weightage",
            router_link: "/admin/Factory/product-weightage-listing",
            is_favorite: false,
            },
            
            {
            label: "Work Load Matrix",
            router_link: "/admin/Factory/work-load-matrix-listing",
            is_favorite: false,
            },
            {
            label: "Standard Lead Time Matrix",
            router_link: "/admin/Factory/standard-lead-time-matrix-listing",
            is_favorite: false,
            },
            {
            label: "Throughput Time Matrix",
            router_link: "/admin/Factory/throughput-time-matrix-listing",
            is_favorite: false,
            },
            {
            label: "Production Quality Excellence Matrix",
            router_link: "/admin/Factory/quality-excellence-matrix-listing",
            is_favorite: false,
            },
            {
            label: "Machine Criticality Benchmark Matrix",
            router_link: "/admin/Factory/criticality-weightage-listing",
            is_favorite: false,
            },
            {
            label: "RM Quality Excellence Matrix",
            router_link: "/admin/Factory/rm-quality-excellence-matrix-listing",
            is_favorite: false,
            },
            {
                label: "R and D Review Matrix",
                router_link: "/admin/Factory/rand-d-review-matrix-listing",
                is_favorite: false,
            },
            {
                label: "RM Distribution Matrix",
                router_link: "/admin/Factory/rm-distribution-matrix-listing",
                is_favorite: false,
            },
        ]
    },
    {icon: 'assets/icon/crm.svg',
        heading: "Factory Checklist Management",
        sub_heading: [
            {
                label: "Factory Checklist Management",
                router_link: "/admin/Factory/factory-checklist-management",
                is_favorite: false,
            },
        
        ]
   },

   {
    icon: 'assets/icon/crm.svg',
    heading: "Jobrole Hierarchy",
    // hideFor: ['FACTORY_MANAGER'],
    sub_heading: [
        {
            label: "Job Role Master",
            router_link: "/admin/Factory/jobrole-master-list",
            is_favorite: false,
        },

        {
            label: "Job Role Assigning",
            router_link: "/admin/Factory/jobrole-hierarchy", 
            is_favorite: false,
        },
    ]
},

{
    icon: 'assets/icon/crm.svg',
    heading: "Live Production Dashboard",
    // hideFor: ['FACTORY_MANAGER'],
    sub_heading: [
            {
                label: "Live Production Dashboard",
                router_link: "/admin/Factory/live-production-dashboard",
                is_favorite: false,
            },
            

    ]
},
        
]